<template>
  <div id="modify_login_pwd">
    <div class="repay_pwd pay_pwd_form">
      <el-form :model="infoForm" :rules="rules" ref="infoForm" label-width="118px" class="demo-ruleForm login-pwd-form">
        <el-form-item label="手机号："  prop="ph_num">
          <div class="personal_info">
            {{infoForm.ph_num}}
          </div>
        </el-form-item>
        <el-form-item label="短信验证码："  prop="v_code" class="v_code">
          <el-input placeholder="请输入短信验证码" autocomplete="new-password" v-model="infoForm.v_code" class="v_code_input"></el-input>
          <div v-if="smsCode" class="v_code_btn" @click="smsSend(infoForm.ph_num)">获取</div>
          <div v-else class="v_code_btn" id="smsFalse" >{{ smsTime }}s</div>
        </el-form-item>
        <el-form-item label="登陆密码："  prop="pwd">
          <el-input placeholder="请输入新登陆密码" autocomplete="new-password" v-model="infoForm.pwd" show-password ></el-input>
        </el-form-item>
        <el-form-item label="确认密码："  prop="re_pwd">
          <el-input placeholder="请确认登陆密码" autocomplete="new-password" v-model="infoForm.re_pwd" show-password></el-input>
        </el-form-item>
      </el-form>
    </div>
    <div class="submit-row">
      <div class="submit_btn" @click="submitForm('infoForm')">确认提交</div>
    </div>
  </div>
</template>
<script>
import {apiSmsSend,apiReset,apiuserInfo} from "@/request/API";

export default {
  name: '',
  props: {
  },
  components: {

  },
  data () {
    var validatePwd = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请再次输入登陆密码'))
      } else if (value !== this.infoForm.pwd) {
        callback(new Error('两次输入密码不一致!'))
      } else {
        callback()
      }
    }
    return {
      //表单
      infoForm:{
        ph_num:this.$store.state.userData.telphone,
        v_code:'',
        pwd:'',
        re_pwd:''
      },
      //表单验证
      rules: {
        v_code: [
          { required: true, message: '请输入验证码', trigger: 'blur' },
        ],
        pwd: [
          { required: true, message: '请输入新登陆密码', trigger: 'blur' },
          { pattern: /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{8,16}$/, message: '密码由8到16位数字和字母组成' }
        ],
        re_pwd: [
          { required: true, validator: validatePwd, trigger: 'blur' }
        ]
      },
      //获取验证码
      smsCode:true,
      smsTime:60
    }
  },
  methods: {
    /**
     * 获取验证码
     * @param phone
     */
    smsSend(phone){
      apiSmsSend({
        phone:phone,
        codeType:this.$store.state.userData.country_code == '86'?0:12,
        country_code:this.$store.state.userData.country_code
      }).then(res => {
        this.$message({
          type:"success",
          center:true,
          message:"发送成功"
        })
        this.smsCode = false
      }).catch(err=>{
        this.$message({
          type:"error",
          center:true,
          message:err.msg
        })
      })

    },
    //表单提交
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          apiReset({
            phone:this.infoForm.ph_num,
            pwd:this.infoForm.pwd,
            pwd_confirm:this.infoForm.re_pwd,
            smsCode:this.infoForm.v_code,
            country_code:this.$store.state.userData.country_code
          }).then(res => {
            this.$message({
              message:"修改密码成功",
              center:true,
              type:"success"
            })
          }).catch(err=>{
            this.$message({
              message:err.msg,
              center:true,
              type:"error"
            })
          })
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    //获取 支付密码 信息
    getBasicInfo(){
      apiuserInfo({
        action:'base'
      }).then(res=>{
        this.infoForm.ph_num = res.data.telphone
      })
    },
    //获取验证码冷却
    countdownTime(){
      this.smsTime--
      if(this.smsTime === 0){
        this.smsCode = true
      }
    }
  },
  mounted () {
    this.getBasicInfo()
  },
  watch: {
    smsCode(val, oldVal){//普通的watch监听
      if(!val){
        this.smsTime = 60
        this.countdown = setInterval(this.countdownTime, 1000);
      }else{
        clearInterval(this.countdown)
      }
    },
  },
  computed: {

  },
  created() {
    if (localStorage.getItem('loginStatus') == "true") {
      this.infoForm.ph_num = JSON.parse(localStorage.getItem('userData')).telphone
    }
  }
}
</script>


<style lang='less' scoped>
#modify_login_pwd{
  width: 100%;
  min-height: 520px;
  padding: 32px 44px 44px;
  display: flex;
  flex-direction: column;
  align-items: center;
  color: var(--text-main, #111827);

  *,
  *:before,
  *:after {
    box-sizing: border-box;
  }

  .pay_pwd_form{
    display: table;
    width: auto;
    max-width: 100%;
    margin: 0 auto;

    .login-pwd-form{
      display: table;
      width: auto;
      max-width: 100%;
    }

    /deep/.el-form-item{
      min-height: 40px;
      margin-bottom: 22px;
    }

    /deep/.el-form-item__content{
      min-height: 40px;
      line-height: 40px;
    }

    /deep/.el-input{
      width: 360px;
      max-width: 100%;
    }

    /deep/.el-input__inner{
      width: 100%;
      height: 40px;
      padding: 0 14px;
      background: var(--bg-tag, #F7F5F2);
      border-radius: 4px;
      border: 1px solid var(--border-soft, #E8E4DE);
      font-size: 15px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: var(--text-main, #111827);
      transition: border-color .2s ease, box-shadow .2s ease, background .2s ease;
    }

    /deep/.el-input__inner:hover{
      border-color: var(--border-strong, #D8D2CA);
      background: #FFFFFF;
    }

    /deep/.el-input__inner:focus{
      border-color: var(--primary, #FF5A1F);
      background: #FFFFFF;
      box-shadow: none;
    }

    /deep/.is-error .el-input__inner{
      border-color: var(--danger, #EF4444);
      box-shadow: 0 0 0 3px rgba(239, 68, 68, 0.08);
    }

    /deep/.el-form-item__error{
      padding-top: 5px;
      color: var(--danger, #EF4444);
    }

    .v_code /deep/.el-form-item__content{
      display: flex;
      align-items: flex-start;
    }

    .v_code_input,
    .v_code_input /deep/.el-input__inner{
      width: 246px;
    }

    .v_code_btn{
      margin: 0 0 0 10px !important;
      width: 104px;
      height: 40px;
      border: 1.5px solid var(--bg-dark, #1A1D24);
      border-radius: 3px;
      background: #FFFFFF;
      color: var(--text-main, #1A1D24);
      cursor: pointer;
      text-align: center;
      display: inline-flex;
      align-items: center;
      justify-content: center;
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 500;
      line-height: 38px;
      transition: color .2s ease, background .2s ease, border-color .2s ease;
    }

    .v_code_btn:hover{
      border-color: var(--bg-dark, #1A1D24);
      background: var(--bg-tag, #F0EDE8);
    }

    #smsFalse{
      color: var(--text-muted, #9AA0AC);
      border-color: var(--border-soft, #E8E4DE);
      background: var(--bg-tag, #F0EDE8);
      cursor: auto;
    }

    /deep/.el-form-item__label{
      padding: 0 16px 0 0;
      text-align: right;
      font-size: 15px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: var(--text-secondary, #5A5F6B);
      line-height: 40px;
    }

    .personal_info{
      display: flex;
      width: 360px;
      max-width: 100%;
      min-height: 40px;
      align-items: center;
      font-size: 15px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: var(--text-main, #111827);
    }
  }

  .submit-row{
    width: 560px;
    max-width: 100%;
    display: flex;
    justify-content: center;
  }

  .submit_btn{
    display: inline-flex;
    margin: 8px 0 0 0;
    width: 200px;
    height: 42px;
    padding: 0;
    align-items: center;
    justify-content: center;
    border: none;
    border-radius: 3px;
    background: var(--primary, #FF5A1F);
    box-shadow: none;
    font-size: 16px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 500;
    color: #FFFFFF;
    text-align: center;
    cursor: pointer;
    line-height: 42px;
    transition: background .2s ease;
  }

  .submit_btn:hover{
    background: var(--primary-hover, #E84A12);
  }

}
</style>
